import { z } from "zod";
import { apiBuilder, prefixApi } from "@zodios/core";

export const portfoliosApiDefinitions = prefixApi(
  "/api/portfolios",
  apiBuilder({
    alias: "getPortfolios",
    method: "get",
    path: "/",
    status: 200,
    parameters: [
      {
        name: "page",
        type: "Query",
        schema: z.number().optional(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().optional(),
      },
      {
        name: "ordering",
        type: "Query",
        schema: z.string().optional(),
      },
      {
        name: "search",
        type: "Query",
        schema: z.string().optional(),
      },
      { name: "market_place", type: "Query", schema: z.string().optional() },
      { name: "portfolio_id", type: "Query", schema: z.string().optional() },
      { name: "portfolio_name", type: "Query", schema: z.string().optional() },
    ],
    response: z.object({
      count: z.number(),
      next: z.string().nullable(),
      previous: z.string().nullable(),
      results: z.array(
        z.object({
          portfolio_id: z.number().int(),
          market_place: z.string(),
          portfolio_name: z.string(),
          portfolio_budget_amount: z.number(),
          portfolio_state: z.string(),
          portfolio_budget_currency_code: z.string().nullable(),
          portfolio_budget_policy: z.string().nullable(),
          portfolio_budget_start_date: z.string().date().nullable(),
          portfolio_budget_end_date: z.string().date().nullable(),
          portfolio_in_budget: z.boolean(),
          portfolio_creation_date: z.number().int(),
          portfolio_last_updated_date: z.number().int(),
          portfolio_serving_status: z.string().nullable(),
          org: z.number().int(),
        }),
      ),
    }),
  }).build(),
);
